import { translate } from '@/domains/core/localization/translate';
export const {
  promoTag
} = translate({
  "promoTag": "Deal"
});